import { render, staticRenderFns } from "./mode.vue?vue&type=template&id=96e40ba4&"
import script from "./mode.vue?vue&type=script&lang=js&"
export * from "./mode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports